import { PushAdminUsersFilters } from "@myapp/contract";
import { notificationApi } from "../api/service";

/** Mirrors EntityMultiSelect's bulk-load ceiling — beyond this "alle" stops being honest UI. */
export const MAX_SELECT_ALL = 500;

/**
 * Resolves "Alle mit Push auswählen" across every page of the current filter, not just the
 * loaded ones. The server clamps `limit` to 100, so this loops pages instead of asking once.
 * `pushStatus` is forced to 'with' — selecting users push cannot reach would only inflate
 * the recipient count with guaranteed 0/0 rows.
 */
export async function fetchAllPushUserIds(
  filters: PushAdminUsersFilters,
): Promise<number[]> {
  const ids: number[] = [];
  let page = 1;

  for (;;) {
    const { data } = await notificationApi.listAdminUsers({
      ...filters,
      pushStatus: "with",
      page,
      limit: 100,
    });
    ids.push(...data.items.map((user) => user.id));

    const loaded = data.meta.page * data.meta.limit;
    if (loaded >= data.meta.total || data.items.length === 0 || ids.length >= MAX_SELECT_ALL) {
      break;
    }
    page += 1;
  }

  return ids.slice(0, MAX_SELECT_ALL);
}
